// src/context/FileContext.js
import React, { createContext, useState, useContext } from "react";

const FileContext = createContext(null);

export const FileProvider = ({ children }) => {
    const [filesMap, setFilesMap] = useState(new Map()); // Map<UID, File>

    const addFile = (uid, file) => {
        setFilesMap((prev) => new Map(prev).set(uid, file));
    };

    const removeFile = (uid) => {
        setFilesMap((prev) => {
            const updated = new Map(prev);
            updated.delete(uid);
            return updated;
        });
    };

    const getFile = (uid) => filesMap.get(uid);

    return (
        <FileContext.Provider
            value={{ filesMap, addFile, removeFile, getFile }}
        >
            {children}
        </FileContext.Provider>
    );
};

export const useFileContext = () => useContext(FileContext);
